import { defineWave } from '../schema';

/** BLOC E2 — LA CRÊTE DU MONDE 2. Les trois natures ensemble.
 *
 *  Dernière brique avant le silence qui précède la Navette, et point de densité
 *  maximale du monde. Elle ne fait entrer aucun ennemi nouveau : elle superpose
 *  ce que les trois blocs précédents ont enseigné séparément.
 *
 *    le Tisseur   impose une trajectoire — il faut suivre
 *    le Mortier   interdit une région    — il faut contourner
 *    le Dard      interdit l'immobilité  — il faut réagir
 *
 *  Les trois consignes sont compatibles, et c'est tout l'enjeu : un joueur qui
 *  n'en a intégré que deux se retrouve à devoir choisir laquelle abandonner. Il
 *  n'y a pourtant rien à sacrifier, seulement un ordre à trouver — suivre le
 *  couloir du mur EN le prenant du côté opposé au Mortier laisse exactement la
 *  place qu'il faut pour répondre aux plongées.
 *
 *  ⚠️ Aucun Mortier après 14 s. Le bloc dure 22 s et le Mortier reste posé
 *  longtemps : un ancrage tardif survivrait au bloc et se retrouverait encore
 *  actif pendant le silence d'avant-boss, ce qui annulerait le silence. La
 *  contrainte est invisible à la lecture du fichier — d'où cette note. */
export default defineWave({
  id: 'e2-crete',
  duration: 22,
  spawns: [
    { at: 0.5, enemy: 'tisseur', lane: 2, count: 1, spacing: 0 },
    { at: 1.0, enemy: 'mortier', lane: 4, count: 1, spacing: 0 },
    // Faucon, le kamikaze : introduit au début, avant que la crête ne se
    // densifie, pour qu'on lise sa charge — approche, puis piqué — sans autre
    // menace à gérer en même temps.
    { at: 3.0, enemy: 'faucon', lane: 3, count: 1, spacing: 0 },
    { at: 4.0, enemy: 'dard', lane: 3, count: 3, spacing: 0.5 },
    { at: 6.5, enemy: 'mite', lane: 1, count: 7, spacing: 0.07 },
    { at: 8.0, enemy: 'faucheur', lane: 5, count: 1, spacing: 0 },
    // Chasseur : la source de la rafale balaie l'écran — pister un tireur mobile.
    { at: 8.5, enemy: 'chasseur', lane: 2, count: 1, spacing: 0 },
    // Mitrailleur : sa rafale de petits lasers demande de tenir un déplacement
    // continu. Il arrive une fois le Faucon compris.
    { at: 9.5, enemy: 'mitrailleur', lane: 3, count: 1, spacing: 0 },
    { at: 10.0, enemy: 'tisseur', lane: 4, count: 1, spacing: 0 },
    { at: 12.0, enemy: 'dard', lane: 1, count: 3, spacing: 0.45 },
    { at: 12.4, enemy: 'dard', lane: 5, count: 3, spacing: 0.45 },
    { at: 14.0, enemy: 'mortier', lane: 2, count: 1, spacing: 0 },
    // Escadrille : deux jumeaux qui tracent un X. Lire un croisement mouvant.
    { at: 15.0, enemy: 'escadrille-a', lane: 1, count: 1, spacing: 0 },
    { at: 15.0, enemy: 'escadrille-b', lane: 5, count: 1, spacing: 0 },
    { at: 16.0, enemy: 'rodeur', lane: 3, count: 1, spacing: 0 },
    { at: 18.0, enemy: 'eclat', lane: 2, count: 3, spacing: 0.5 },
    { at: 18.4, enemy: 'eclat', lane: 4, count: 3, spacing: 0.5 },
  ],
});
